<template>
	<div class="printing-wrap">
		<!-- 报告单首页 -->
		<div class="printing" >
			<div class="report-corver">
				<img src="../assets/report-logo.png" alt="图片" />
			</div>
			<div class="report-dete">
				<img src="../assets/report-size.png" alt="图片" />
			</div>
			<div class="report-naologo">
				<img src="../assets/report-corver.png" alt="logo" />
			</div>
			<div class="report-age-sex">
				<ul>
					<li>姓名:</li>
					<li>性别:</li>
					<li>年龄:</li>
					<li>日期:</li>
				</ul>               
				<div>
					<p>{{getPrintPageFirst.name}}</p>
					<p v-html="getPrintPageFirst.userSex==1?'女':'男'"></p>
					<p>{{getPrintPageFirst.userAge}}</p>
					<p>{{getPrintPageFirst.createtime}}</p>
				</div>
			</div>
			<div class="report-mumber">
				<p>报告单号：<b>{{getPrintPageFirst.cpNumber}}</b></p>
			</div>
		</div>
		<!-- 阅读指南-->
		<div class="printing">
			<h2 class="printing-header">
				<img src="../assets/read-guid.png" alt="图片" />
			</h2>
			<div class="read-guid">
				<p>5-9岁是大脑发育的重要阶段，此阶段孩子正处于从前具体运算阶段（表象思维）到具体运算阶段（出现逻辑思维）的关键阶段，脑功能检测可以探讨动态脑功能网络。本报告将根据检测结果，对您孩子的脑功能进行精准分析，提供
				 <span v-if = 'getPrintPageFirst.gameCount  == 4'>脑功能图谱的优劣势解读和</span> 专业个性化提升方案，为孩子的脑效率和脑健康保驾护航。</p>
			</div>
			<h3 class="printing-left">
				<img src="../assets/read-prin.png" alt="图片" />
			</h3>
			<div class="read-prin">
				<p class="read-prin-bot">首先，检测结果受环境、大脑发育状态、个人状态影响。越安静的环境、发育越好的大脑、越良好的状态，检测结果和您孩子的实际情况越符合。值得注意的是，在5-9岁这一阶段，儿童大脑发育较快，且发育过程中不同脑功能发展的先后顺序存在个体差异，因此本报告中呈现的脑功能检测结果和分析，只是您孩子这一段时间内的状态，建议您从发展的角度看待孩子的脑功能状态，不要形成刻板印象。</p>
				<p>其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您孩子的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。</p>
			</div>
			<h6 class="sore-table-title">表 得分与脑功能表现、人数占比对应表</h6>
			<div class="read-table">
				<table>
					<tr>
						<th>得分</th>
						<th>脑健康</th>
						<th>脑效率</th>
						<th>人数占比</th>
					</tr>
					<tr>
						<td>[75~100<span class="numjia">＋</span></td>
						<td>健康</td>
						<td>出色</td>
						<td>6%</td>
					</tr>
					<tr>
						<td>[60~75)</td>
 						<td>健康</td>
						<td>良好</td>
						<td>24%</td>
					</tr>
					<tr>
						<td>[25-60)</td>
						<td>亚健康</td>
						<td>中等</td>
						<td>64%</td>
					</tr>
					<tr>
						<td>[0-25)</td>
						<td>不健康</td>
						<td>欠佳</td>
						<td>6%</td>
					</tr>
				</table>
			</div>
			<div class="read-table-bot">
				<p>最后，本报告包含了<span>{{getPrintPageFirst.gameCount}}</span>个脑功能检测项目的结果，并根据孩子的结果提供<span v-if = 'getPrintPageFirst.gameCount  == 4'>综合解读和</span>单项脑功能提升方案。
				<span v-if = 'getPrintPageFirst.gameCount  == 4'>您可按照顺序先阅读综合脑功能结果与解读，再阅读各单项脑功能的提升方案。</span></p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>
		</div>
		<!-- 检测结果全貌 -->
		<div class="printing">
			<h2 class="printing-header">
				<img src="../assets/childTitle-one.png" alt="图片" />
			</h2>
			<p class="score-Introduction">
				本次检测包含{{getPrintPageFirst.gameNames}}任务脑功能项目。<span v-if = "getPrintPageFirst.gameCount > 1">您孩子脑功能的综合得分为<span>{{getPrintPageFirst.score}}</span>超过所处年龄段<span>{{getPrintPageFirst.agegroup}}{{getPrintPageFirst.exceed}}%</span>的人，处于<span>{{getPrintPageFirst.health}}</span>状态，脑效率处于<span>{{getPrintPageFirst.efficiency}}</span>水平。</span>以下是各项脑功能检测结果具体情况:
			</p>
			<h6 class="table-title">
				表1 脑功能检测结果表
			</h6>
			<div class="printing-table">
				<table>
					<tr>
						<th>检测项目</th>
						<th>题目数</th>
						<th>正确数</th>
						<th>正确率</th>
						<th>反应时</th>
						<th>得分</th>
						<th>超过</th>
						<th>脑功能</th>
						<th>脑效率</th>
						<th>脑健康</th>
					</tr>
					<tr v-for="(item,index) in getscoreList">
						<td>{{item.gameName}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.number}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.correctNum}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.correctRate}}%</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.time}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.score}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.exceed}}%</td>   
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.brainFunction}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.brainEfficiency}}</td>
						<td v-bind:style="{'color': color(item.brainHealth)}">{{item.brainHealth}}</td>
					</tr>
				</table>
			</div>
			<p class="coefficient-Interpretation">
				<b>系数解读:</b> a. 反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您孩子的该项脑功能处于不健康状态，蓝色字体表示您孩子的该项脑功能处于亚健康状态。
			</p>
			<p class="coefficient-Interpretation">
				<b>脑功能解读:</b><span v-for = "(item,index) in brainVosList">{{item}}</span>
			</p>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>
		</div>
		<!-- 综合解读建议 -->
		<div class="printing" v-if = "getPrintPageFirst.gameCount  == 4">
			<h2 class="printing-header">
				<img src="../assets/childTitle-two.png" alt="图片"/>
			</h2>
			<p class="brain-bot">
				根据对您孩子的数字比较任务、图形推理任务、数字倒背任务、瞬数圆点任务这四项任务表现的综合分析，您孩子的脑功能模式属于<span>{{this.brainsuggest.brainType}}</span>。见图1:
			</p>
			<div class="echart-barin">
				<div id="radarChart" :style="{width: '400px', height: '400px'}"></div>
			</div>
			<div class="brain-img-bot">
				图1 脑功能图谱
			</div>
			<h6 class="factor">图谱解读</h6>
			<div class="map-inter">
				<p>{{brainsuggest.unscramble}}</p>
				<p>{{brainsuggest.reason}}</p>    
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num"></a>
			</div>                                                                                                                                                     
		</div>
		<!-- 执行功能提升表格1 -->
		<div class="printing" v-if = "getshuzibijiao.status == 1">
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount !==4">
				<img src="../assets/childTitle-three.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount  == 4">
				<img src="../assets/childTitle-three-one.png" alt="图片" />
			</h2>
			<p class="Suggest" v-if = "getPrintPageFirst.gameCount  == 4">{{brainsuggest.advice}}</p>
			<h3 class="printing-left">
				<img src="../assets/childTitle.png" alt="图片" />
				<span class="childTitle-size" v-html = "getshuzibijiao.brainCapacity"></span>
			</h3>
				<p class="Suggest">{{getshuzibijiao.advice}}</p>
			<div class="sport-table">
				<table v-if = "this.shuzibijiaoList.length<=3">
					<tr v-for = "(item,index) in shuzibijiaoList">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
				<table v-if = "this.shuzibijiaoList.length>3">
					<tr v-for = "(item,index) in shuzibijiaoList1">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried5"></a>
			</div>
		</div>
		<!-- 执行功能提升表格2 -->
		<div class="printing" v-if = "this.shuzibijiaoList.length >3 && getshuzibijiao.status == 1">
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount !==4">
				<img src="../assets/childTitle-three.png" alt="图片" />
			</h2>
			<h2 class="printing-header"  v-if = "getPrintPageFirst.gameCount  == 4">
				<img src="../assets/childTitle-three-one.png" alt="图片" />
			</h2>
			<h3 class="printing-left">
				<img src="../assets/childTitle.png" alt="图片" />
				<span class="childTitle-size" v-html = "getshuzibijiao.brainCapacity"></span>
			</h3>
			<div class="sport-table">
				<table>
					<tr v-for = "(item,index) in shuzibijiaoList2">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried5"></a>
			</div>
		</div>
		<!-- 逻辑推理提升表格 -->
		<div class="printing" v-if = "getluojituili.status == 1">
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount !==4">
				<img src="../assets/childTitle-three.png" alt="图片" />
			</h2>
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount  == 4">
				<img src="../assets/childTitle-three-one.png" alt="图片" />
			</h2>
			<h3 class="printing-left">
				<img src="../assets/childTitle.png" alt="图片" />
				<span class="childTitle-size" v-html = "getluojituili.brainCapacity"></span>
			</h3>
				<p class="Suggest">{{getluojituili.advice}}</p>
			<div class="sport-table">
				<table>
					<tr v-for = "(item,index) in luojituiliList">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried5"></a>
			</div>
		</div>
		<!-- 工作记忆提升表格 -->
		<div class="printing" v-if = "getgongzuojiyi.status == 1">
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount !==4">
				<img src="../assets/childTitle-three.png" alt="图片" />
			</h2>
			<h2 class="printing-header"  v-if = "getPrintPageFirst.gameCount  == 4">
				<img src="../assets/childTitle-three-one.png" alt="图片" />
			</h2>
			<h3 class="printing-left">
				<img src="../assets/childTitle.png" alt="图片" />
				<span class="childTitle-size" v-html = "getgongzuojiyi.brainCapacity"></span>
			</h3>
				<p class="Suggest">{{getgongzuojiyi.advice}}</p>
			<div class="sport-table">
				<table>
					<tr v-for = "(item,index) in gongzuojiyiList">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried5"></a>
			</div>
		</div>
		<!-- 注意广度提升表格 -->
		<div class="printing" v-if = "zhuyiguangdu.status == 1">
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount !==4">
				<img src="../assets/childTitle-three.png" alt="图片" />
			</h2>
			<h2 class="printing-header"  v-if = "getPrintPageFirst.gameCount  == 4">
				<img src="../assets/childTitle-three-one.png" alt="图片" />
			</h2>
			<h3 class="printing-left">
				<img src="../assets/childTitle.png" alt="图片" />
				<span class="childTitle-size" v-html = "zhuyiguangdu.brainCapacity"></span>
			</h3>
				<p class="Suggest">{{zhuyiguangdu.advice}}</p>
			<div class="sport-table">
				<table>
					<tr v-for = "(item,index) in zhuyiguangduList">
						<td>{{item.title}}</td>
						<td>{{item.advice}}</td>
					</tr>
				</table>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num carried5"></a>
			</div>
		</div>
		<!-- 后记 -->
		<div class="printing" >
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount  == 4">
				<img src="../assets/postscript.png" alt="图片"/>
			</h2>
			<h2 class="printing-header" v-if = "getPrintPageFirst.gameCount !==4">
				<img src="../assets/houji-two.png" alt="图片"/>
			</h2>
			<div class="Follow-up">
				<p>1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价孩子的脑功能，但科学检测是深入了解脑功能的一扇门。</p>
				<p>2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使孩子的结果更真实。</p>
				<p>3、儿童和青少年时期处于脑功能发展的关键阶段，孩子的脑功能水平会随着年龄的增长而不断变化。因此，本次脑功能检测，只代表孩子现在所处年龄段的水平，建议您持续关注孩子的脑健康和脑效率。</p>
				<p>4、本检测主要用于评估孩子的基础脑功能，如果您想用于评价孩子的个人能力和学业能力发展，建议结合专业的人格、成就等测试。此外，越全面的脑功能检测，用于评价个人能力和学业能力发展的效度越高。</p>
			</div>
			<div class="QR-code">
				<img src="../assets/QR-code.jpg" alt="六六脑官方微信">
				<p class="QR-we">六六脑官方微信</p>
				<p class="QR-we" style="font-weight:bolder">更多脑能力测评请登录<a  target="_Blank" href="http://cp.66nao.com">cp.66nao.com</a></p>
			</div>
			<div class="page-Increment">
				<a class="page-size">{{getPrintPageFirst.cpNumber}}</a>
				<a class="page-img">
					<img src="../assets/page.png" alt="图片" />
				</a>
				<a class="page-num postscript"></a>
			</div>
		</div>
		<a href="javascript:;" class="closePrint" title="打印" @click = "print_page()" ></a>
		<a href="javascript:;" class="closePage" title="关闭" @click = "print_close()"></a>
		<a href="javascript:;" class="moveUp" title="回到顶部"></a>
	</div>
</template>
<style lang = "scss">
	@import "../styles/core/reset.scss";
	@page {
		size: auto A4 landscape;
		margin: 0mm;
	}
	.printing-wrap {
		.printing {
			position: relative;
			width: 12.40rem;
			height: 16.68rem;
			background: #fff;
			margin: 0 auto 0.1rem;
			page-break-after: always;
			.report-corver {
				height: 0.49rem;
				line-height: 0.49rem;
				padding-top: 1.70rem;
				width: 2.50rem;
				margin: 0 auto;
			}
			.report-dete {
				width: 5.04rem;
				height: 3.05rem;
				margin: 0 auto;
				margin-top: .45rem;
			}
			.report-naologo {
				width: 7.14rem;
				height: 5.50rem;
				margin: 0 auto;
				img {
					margin-top: 0.44rem;
				}
			}
			.report-age-sex {
				width: 4.36rem;
				font-size: 32px;
				color: #000000;
				line-height: 59px;
				margin: 0 auto;
				margin-top: 1.31rem;
				@include flexbox;
				ul {
					padding-right: 0.28rem; 
					width: 0.96rem;
					font-weight: bold;
				}
				div {
					@include flex;
					p {
						width: 3.10rem;
						height: 0.59rem;
						text-align: center;
						border-bottom: 1px solid #000000;
					}
				}
			}
			.report-mumber {
				margin: 0 auto;
				height: 0.33rem;
				line-height: 0.33rem;
				text-align: center;
				margin-top: 1.06rem;
				padding-bottom: 0.4rem;
				p {
					font-family: PingFangTC-Semibold;
					font-size: 24px;
					color: #444444;
				}
			}
			.printing-header {
				width: 10.40rem;
				height: 0.9rem;
				padding-top: 0.95rem;
				margin-bottom: 0.8rem;
				img {
					margin: 0 1rem;
				}
			}
			.read-guid {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
					margin-bottom: 0.60rem;
				}
			}
			.printing-left {
				height: 0.6rem;
				margin: 0 auto 0.4rem;
				img {
					height: 0.6rem;
					position: relative;
				}
			}
			.childTitle-size{
				font-size: 0.26rem;
				color: #FFFFFF;
				z-index: 99;
				position: absolute;
				left: 1.2rem;
				height: 0.52rem;
				line-height: 0.52rem;
				font-family: PingFangTC-Semibold;
				letter-spacing: 1px;
			}
			.childTitle-size-right{
					padding-right:2px;
				}
			.read-prin {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
				.read-prin-bot {
					margin-bottom: 0.1rem;
				}
			}
			.sore-table-title {
				font-size: 24px;
				color: #333333;
				line-height: 33px;
				text-align: center;
				margin-top: 0.4rem;
				margin-bottom: 0.2rem;
			}
			.read-table {
				width: 10.16rem;
				margin: 0 auto;
				font-size: 0.2rem;
				table {
					th {
						background: #DBDBDB;
						width: 2.54rem;
						height: 0.6rem;
						font-weight: normal;
						color: #333333;
						border-right: 1px solid #979797;
					}
					tr {
						height: .6rem;
						box-sizing: border-box;
						text-align: center;
						border: 1px solid #DDDDDD;
					}
					th:nth-last-child(1) {
						border-right: none;
					}
					tr:nth-child(even) {
						background: #FDFDFF;
					}
					tr:nth-child(odd) {
						background: #EEEEEE;
					}
					td {
						border-right: 1px solid #979797;
						white-space: nowrap;
					}
					.numjia{
						vertical-align:super;
					}
				}
			}
			.read-table-bot {
				width: 10.40rem;
				margin: 0.30rem auto 0;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
				}
			}
			.page-Increment {
				position: absolute;
				bottom: 0.26rem;
				right: 1rem;
				.page-size {
					font-size: 14px;
					color: #000000;
				}
				.page-img {
					font-size: 11px;
					color: #FFFFFF;
				}
				.page-num {
					font-size: 20px;
					color: #000000;
				}
			}
			.score-Introduction {
				width: 10.40rem;
				margin: 0 auto;
				line-height: 0.33rem;
				font-size: 0.24rem;
				color: #444444;
				text-indent: 0.48rem;
			}
			.table-title {
				margin: 0.40rem auto 0.20rem;
				font-size: 24px;
				color: #333333;
				height: 0.33rem;
				line-height: 0.33rem;
				text-align: center;
			}
			.printing-table {
				width: 10.16rem;
				margin: 0 auto;
				font-size: 0.2rem;
				table {
					th {
						background: #DBDBDB;
						width: 1.01rem;
						height: 0.6rem;
						font-weight: normal;
						color: #333333;
						border-right: 1px solid #979797;
					}
					th:nth-last-child(1) {
						border-right: none;
					}
					tr {
						height: .6rem;
						box-sizing: border-box;
						text-align: center;   
						border: 1px solid #DDDDDD;
					}
					tr:nth-child(even) {
						background: #FDFDFF;
					}
					tr:nth-child(odd) {
						background: #EEEEEE;
					}
					td {
						border-right: 1px solid #979797;
						white-space: nowrap;
						&.red{
							color: red;
						}
						&.blue{
							color: blue;
						}
					}
				}
			}
			.coefficient-Interpretation {
				width: 10.40rem;
				margin: 0.32rem auto 0.60rem;
				line-height: 0.33rem;
				font-size: 0.24rem;
				color: #444444;
				text-indent: 0.48rem;
				b {
					color: #000000;
				}
			}
			.brain-bot {
				width: 10.40rem;
				margin: 0.40rem auto 0.62rem;
				line-height: 0.33rem;
				font-size: 0.24rem;
				color: #444444;
				text-indent: 0.48rem
			}
			.echart-barin {
				width: 3.68rem;
				height: 3.68rem;
				margin: 0 auto;  
				text-align: center;
				#radarChart {
					width: 3.68rem;
					height: 3.68rem; 
				}
			}
			.brain-img-bot {
				height: 0.33rem;
				margin: 0.75rem auto 0.38rem;
				font-size: 24px;
				color: #333333;
				line-height: 33px;
				text-align: center;
				font-weight: bolder;
			}
			.factor {
				margin: 0.61rem 0 0.24rem 1rem;
				font-size: 24px;
				color: #444444;
				line-height: 33px;
			}
			.map-inter {
				width: 10.40rem;
				margin: 0 auto 0.60rem;
				p {
					line-height: 0.33rem;
					font-size: 0.24rem;
					color: #444444;
					text-indent: 0.48rem;
					padding-bottom: 0.15rem;
				}
			}
			.Suggest {
				margin: 0.2rem 1rem 0.2rem 1rem;
				font-family: PingFangTC-Regular;
				font-size: 24px;
				color: #444444;
				line-height: 33px;
			}
			.sport-table {
				width: 10.40rem;
				margin: 0 auto;
				table {
					margin-bottom: 0.4rem;
					border: 1px solid #979797;
					tr {
						box-sizing: border-box;
						text-align: center;
						line-height: 33px;
					}
					td {
						border-right: 1px solid #979797;
						border-top: 1px solid #979797;
					}
					td:nth-child(1) {
						width: 3.14rem;
						font-size: 24px;
						color: #444444;
						line-height: 33px;
						background: #DFF4F8;
						padding-left: 0.3rem;
						padding-right: 0.3rem;
					}
					td:nth-child(2) {
						width: 7.26rem;
						font-size: 20px;
						color: #444444;
						line-height: 33px;
						padding: 0.38rem 0.46rem 0.37rem 0.4rem;
						text-indent: 48px;
						text-align: left;
					}
				}
			}
			.Follow-up {
				width: 10.40rem;
				margin: 0 auto;
				p {
					font-size: 24px;
					color: #444444;
					line-height: 33px;
					text-indent: 48px;
					margin-bottom: 0.1rem;
				}
			}
		}
		.QR-code {
				position: absolute;
				bottom: 2rem;
				right: 40%;
				img{
					width: 2rem;
					height: 2rem;
					margin-left: 18%;
				}
				.QR-we{
					text-align: center;
					font-size: 0.22rem;
					padding-bottom:0.12rem;
					a{
					  color: rgb(68, 154, 208);
		              text-decoration: underline;
		              font-weight: 400;
		              cursor: pointer;
		              padding-left: 0.05rem;
					}
				}
			}
		.closePrint{
			width: 60px;
			height: 60px;
			position: fixed;
			left: 50%;
			display: block;
			bottom:190px;
			background: url(../assets/printM.png)  no-repeat left top;
			margin-left: 660px;
		}
		.closePrint:hover{
			background: url(../assets/printHover.png)  no-repeat left top;
		}
		.closePage{
			width: 60px;
			height: 60px;
			position: fixed;
			left: 50%;
			display: block;
			bottom:120px;
			background: url(../assets/closeM.png)  no-repeat left top;
			margin-left: 660px;
		}
		.closePage:hover{
			background: url(../assets/closeHover.png)  no-repeat left top;
		}
		.moveUp{
			width: 60px;
			height: 60px;
			position: fixed;
			left: 50%;
			display: none;
			bottom:50px;
			background: url(../assets/moveUp.png)  no-repeat left top;
			margin-left: 660px;
		}
		.moveUp:hover{
			background: url(../assets/moveHover.png)  no-repeat left top;
		}
	}
</style>
<script>
	// 引入基本模板
	let echarts = require('echarts/lib/echarts')
	// 引入柱状图组件
	require('echarts/lib/chart/bar')
	// 引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	export default {
		data() {
				return {
					// 首页
					getPrintPageFirst: {},//报告单首页信息
					getPrintPage: {},//检测结果全貌
					getscoreList: {},//表一的检测结果
					brainsuggest: {},//脑功能图谱的解读以及建议
					radarList: {},//雷达图参数
					getshuzibijiao: {},//数字比较的提升方案
					shuzibijiaoList:{},//数字比较的list
					getluojituili:{},//图形推理的提升方案
					luojituiliList:{},//逻辑推理的表格
					getgongzuojiyi:{},//工作记忆的提升方案
					gongzuojiyiList: {},//工作记忆的表格
					zhuyiguangdu:{},//注意广度的提升方案
					zhuyiguangduList: {},//注意广度的表格
					brainVosList:{},//脑功能解读
				}
			},
			mounted() {
				// 提升方案
				var token = localStorage.getItem('token')
	    	 	 this.$http.post(urls.urlReport + '/report/individual.json', {
				 token:token,
				 eid: localStorage.getItem('eid')
				}).then(function(res) {
					console.log(res.body)
					this.getshuzibijiao = res.body.szbjResult //数字比较的提升方案
					this.shuzibijiaoList = res.body.szbjResult.list //数字比较的提升方案
					this.getluojituili = res.body.txtlResult//图形推理的提升方案
					this.luojituiliList = res.body.txtlResult.list//逻辑推理的表格
					this.getgongzuojiyi = res.body.szdbResult//工作记忆的提升方案
					this.gongzuojiyiList = res.body.szdbResult.list//工作记忆的表格
					this.zhuyiguangdu = res.body.ssydResult//注意广度的提升方案
					this.zhuyiguangduList = res.body.ssydResult.list//注意广度的表格
					if(this.shuzibijiaoList.length >3){
						var shuzibijiaoList1 = [];
						var shuzibijiaoList2 = [];
						shuzibijiaoList2.push(this.shuzibijiaoList[this.shuzibijiaoList.length-1])
						console.log(shuzibijiaoList2)
						var numL = this.shuzibijiaoList.length-1;
						for(var i=0;i<numL;i++){
							shuzibijiaoList1.push(this.shuzibijiaoList[i])
						}
						this.shuzibijiaoList1 = shuzibijiaoList1;
						this.shuzibijiaoList2 = shuzibijiaoList2;
					}
				})
				this.addDiv();
				var timer = null;
				var isTop = true;
				var clientHeight = document.documentElement.clientHeight;
				// 滚动条滚动中触发
				window.onscroll = function(){
					var osTop = document.documentElement.scrollTop || document.body.scrollTop;
					if(osTop >= clientHeight){
						$('.moveUp').css('display','block')
					}else{
						$('.moveUp').css('display','none')
					}
					if(!isTop){
						clearInterval(timer)
					}
					isTop = false;
				}
				
				$('.moveUp').click(function(){
					timer = setInterval(function(){
						//当前屏幕的滚动的高度具体顶部的高度
						var osTop = document.documentElement.scrollTop || document.body.scrollTop;
						var ispeeed = Math.floor(-osTop/5)
						document.documentElement.scrollTop = document.body.scrollTop = osTop+ispeeed;	
						// console.log( osTop+ispeeed)
						isTop = true;
						if (osTop == 0) {
							clearInterval(timer)
						}
					},30)
				})
			},
			methods: {
				// 雷达图
				drawLine() {
					//雷达图
					var token = localStorage.getItem('token')
					this.$http.post(urls.urlReport + '/report/getBrainAtlas.json', {
					    token:token,
						eid: localStorage.getItem('eid')
					}).then(function(res) {
						this.radarList = res.body;//雷达图参数
						let myChart = this.$echarts.init(document.getElementById('radarChart'))
						myChart.setOption({
							radar: {
								indicator: [{
									text: '逻辑型',
									max: 100
								}, {
									text: '语言型',
									max: 100
								}, {
									text: '记忆型',
									max: 100
								}, {
									text: '灵活型',
									max: 100
								}],
								nameGap: 4, // 图中工艺等字距离图的距离
								center: ['50%', '50%'],
								radius: '80%',
								// startAngle: 45,
								startAngle: 90,
								splitNumber: 3,
								shape: 'circle',
								name: {
									show: true, // 是否显示工艺等文字
									formatter: null, // 文字的显示形式
									textStyle: {
										color: '#000000' //文字的颜色
									},
									axisLine: {}
								},
								splitArea: {
									areaStyle: {
										color: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'] //每一个区域的颜色
									}
								},
								axisTick: {
									show: true,
									lineStyle: {
										color: 'rgba(255, 255, 255, 0.8)' //未知
									}
								},

								axisLine: {
									lineStyle: {
										color: 'rgba((255, 255, 255, 0.4)' //十字架的颜色
									}
								},
								splitLine: {
									lineStyle: {
										color: '#DDDDDD' //外圈的颜色
									}
								},
							},
							series: [{
								type: 'radar',
							    symbol: "none", // 去掉图表中各个图区域的边框线拐点
								tooltip: {
									trigger: 'item'
								},
								itemStyle: {
									normal: {
										areaStyle: {
											color:'#5089F4'//背景填充色
										},
										lineStyle: {
		                                    color:"#5089F4" // 图表中各个图区域的边框线颜色
		                                },
									},
								},
								data: [{
									value: [this.radarList[0], this.radarList[1], this.radarList[2], this.radarList[3]],
									name: '雷达图'
								}]
							}]
						});
					})
				},
				// 字体颜色
				color(col) {
						if(col == '不健康') return "#FD836A"
			            if(col  ==  '亚健康') return "#5089F4"
						},
				addDiv() {
					setTimeout(function(){
						$(function () {
					       $('.printing').each(function (index, dom) {
					       	var pageindex =  index < 10 ? "0" + index : index;
					           $(dom).find('.page-num').html(pageindex);

					       })
				   		 });
					},600)
				},
				print_close() {
					window.close();
				},
				print_page() {
					window.print();
				}
			},//methods
			created() {    
		    	 //报告首页
		    	var token = localStorage.getItem('token')
	    	 	 this.$http.post(urls.urlReport + '/report/exinfo.json', {
				 token:token,
				 eid: localStorage.getItem('eid')
				 // eid:984
				}).then(function(res) {
					console.log(res.body)
					this.getPrintPageFirst = res.body//报告单首页信息以及检测全貌的信息
					this.getscoreList = res.body.resultBos//表一的检测结果
					this.brainsuggest = res.body.brainAtlas//脑功能图谱的解读以及建议
					this.brainVosList = res.body.brainVos;//脑功能解读
					this.$nextTick(function(){
						if(this.getPrintPageFirst.gameCount  == 4){
							this.drawLine();//雷达图
						}
					})
				})
			},
	}
</script>


// WEBPACK FOOTER //
// mechanismCard.vue?e1c4d2d0